// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgInspace24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g clipPath="url(#clip0_5977_335494)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M20.8799 5.76875L13.4828 2.06589C12.5485 1.60304 11.4514 1.60304 10.5171 2.06589L3.11993 5.76875C1.99707 6.32589 1.28564 7.47446 1.28564 8.73446V15.9688C1.28564 17.2202 1.99707 18.3688 3.11993 18.9345L10.5256 22.6373C11.4599 23.1002 12.5571 23.1002 13.4914 22.6373L20.8971 18.9345C22.0199 18.3773 22.7314 17.2288 22.7314 15.9688V8.73446C22.7314 7.48304 22.0199 6.33446 20.8971 5.76875H20.8799ZM11.2714 3.57446C11.7256 3.34304 12.2656 3.34304 12.7199 3.57446L19.3628 6.89161L11.9828 10.5773L4.36279 7.02875L11.2714 3.57446ZM3.87422 17.4088C3.32564 17.1345 2.97422 16.5688 2.97422 15.9602V8.72589C2.97422 8.57161 2.99993 8.41732 3.04279 8.27161L11.1599 12.0602V21.0602L3.87422 17.4173V17.4088ZM21.0256 12.7288V15.9602C21.0256 16.5773 20.6742 17.1345 20.1256 17.4088L12.8399 21.0516V12.0345L20.8542 8.03161C20.9571 8.24589 21.0256 8.47732 21.0256 8.72589V12.7288Z"
					/>
				</g>
				<defs>
					<clipPath id="clip0_5977_335494">
						<rect width={21.4286} height={21.2571} transform="translate(1.28564 1.71436)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgInspace24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgInspace24;
